export default "__VITE_ASSET__C$nR7Q09__"